export const LOADING_ASSIGN_COMPETENCIES = "LOADING_ASSIGN_COMPETENCIES";
export const SAVE_LOADING_ASSIGN_COMPETENCIES = "SAVE_LOADING_ASSIGN_COMPETENCIES";
export const GET_ASSIGN_COMPETENCIES = "GET_ASSIGN_COMPETENCIES";
export const FORM_FAIL_ASSIGN_COMPETENCIES = "FORM_FAIL_ASSIGN_COMPETENCIES";
export const ASSIGN_COMPETENCIES_FAIL = "ASSIGN_COMPETENCIES_FAIL";
export const LOADING_ASSIGN_COMPETENCIES_BY_ID = "LOADING_ASSIGN_COMPETENCIES_BY_ID";
export const GET_ASSIGN_COMPETENCIES_BY_ID = "GET_ASSIGN_COMPETENCIES_BY_ID";
export const SAVE_LOADING_ASSIGN_COMPETENCIES_BY_ID = "SAVE_LOADING_ASSIGN_COMPETENCIES_BY_ID";
